import React from 'react';

interface MonthYearPickerProps {
  value: string; // Format: "YYYY-MM"
  onChange: (value: string) => void;
  id?: string;
  className?: string;
  min?: string; // Format: "YYYY-MM"
  max?: string; // Format: "YYYY-MM"
}

const MONTHS = [
  { value: '01', label: 'January' },
  { value: '02', label: 'February' },
  { value: '03', label: 'March' },
  { value: '04', label: 'April' },
  { value: '05', label: 'May' },
  { value: '06', label: 'June' },
  { value: '07', label: 'July' },
  { value: '08', label: 'August' },
  { value: '09', label: 'September' },
  { value: '10', label: 'October' },
  { value: '11', label: 'November' },
  { value: '12', label: 'December' },
];

export const MonthYearPicker: React.FC<MonthYearPickerProps> = ({
  value,
  onChange,
  id,
  className = '',
  min,
  max,
}) => {
  const [year, month] = value.split('-');
  
  const currentYear = new Date().getFullYear();
  const years: number[] = [];
  // Generate years from 5 years ago to 5 years ahead
  for (let y = currentYear - 5; y <= currentYear + 5; y++) {
    years.push(y);
  }

  const handleMonthChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newMonth = e.target.value;
    const newValue = `${year}-${newMonth}`;
    if (isValidValue(newValue)) {
      onChange(newValue);
    }
  };

  const handleYearChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newYear = e.target.value;
    const newValue = `${newYear}-${month}`;
    if (isValidValue(newValue)) {
      onChange(newValue);
    }
  };

  const isValidValue = (val: string): boolean => {
    if (min && val < min) return false;
    if (max && val > max) return false;
    return true;
  };

  return (
    <div id={id} className={`flex items-center gap-2 ${className}`}>
      <select
        value={month}
        onChange={handleMonthChange}
        className="border rounded px-2 py-1 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-blue-500"
        aria-label="Month"
      >
        {MONTHS.map((m) => (
          <option key={m.value} value={m.value}>
            {m.label}
          </option>
        ))}
      </select>
      <select
        value={year}
        onChange={handleYearChange}
        className="border rounded px-2 py-1 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-blue-500"
        aria-label="Year"
      >
        {years.map((y) => (
          <option key={y} value={y}>
            {y}
          </option>
        ))}
      </select>
    </div>
  );
};

